import { inject } from '@angular/core';
import { Location } from '@angular/common';
import { CanActivateFn, Router } from '@angular/router';
import { AuthStore } from './state/auth.store';
import { AuthRedirectStore } from './state/auth-redirect.store';

export const createAuthGuard = (): CanActivateFn => {
  return (route, state) => {
    const authStore = inject(AuthStore);
    const router = inject(Router);
    const location = inject(Location);
    const authRedirectStore = inject(AuthRedirectStore);
    const targetUrl = state.url;

    if (!authStore.isAuthenticated()) {
      if (
        targetUrl.startsWith('/app') ||
        targetUrl.startsWith('/impersonate')
      ) {
        authRedirectStore.storeUrl(targetUrl);
        location.replaceState('/');
      }
      return true;
    }

    const redirectUrl = authRedirectStore.getAndClearUrl();
    if (redirectUrl) {
      return router.createUrlTree([redirectUrl]);
    }

    return true;
  };
};

export const authGuard = createAuthGuard();
